/**
 * valveEvents — cross-cutting bus between the axios clients (non-React) and the
 * React layer for the valve "sectionPaused" state.
 *
 * When the section gate returns 503 sectionPaused to a non-exempt user, the
 * axios clients call notifySectionPaused(payload) → a window CustomEvent. The
 * React ValvePauseGate (mounted once in App.js) hears it and shows the approved
 * pop-up over the dimmed area, whose only action is "Check status" → /status.
 *
 * Payload from sectionGate (503 body):
 *   { success:false, sectionPaused:true, valve, message, eta }
 */

export const SECTION_PAUSED_EVENT = 'burrow:section-paused';

export const notifySectionPaused = (payload) => {
  try {
    window.dispatchEvent(new CustomEvent(SECTION_PAUSED_EVENT, {
      detail: payload || {}
    }));
  } catch (err) {
    // Never let a notice crash the caller (e.g. during SSR/tests without window)
    if (typeof console !== 'undefined') console.error('[valveEvents]', err.message);
  }
};

const valveEvents = { SECTION_PAUSED_EVENT, notifySectionPaused };
export default valveEvents;
